import React from "react"
import TitleTab from "../../../shared/components/atoms/title-tab/title-tab"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import { siteUrl } from "../../../shared/utils/siteUrl"

import "./section-article-recommended.scss"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"

const SectionArticleRecommended = props => {
  const userInfoEncrypt= encryptUserInfo()
  const cardRedirect = recomendado => {
    window.location.href = siteUrl + "/entre-nosotras/" + recomendado.slug
    pushDataLayerEvent({
      event: "Interacciones - Articulos",
      category: "Entre Nosotras",
      sub_category: `Cuidado Femenino > ${props.activeCategoryTitle || 'Todos'}`,
      action: "click",
      label: recomendado.tituloArticulo,
      article_name: recomendado.tituloArticulo,
      location: window.location.href,
      article_type: recomendado.tipoDeArticulo,
      user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
      log_status: userInfoEncrypt.log_status,
    })
    pushDataLayerEvent({
      event: "article_click",
      link_text: recomendado.tituloArticulo,
      link_url: window.location.href,
      article_name: recomendado.tituloArticulo
    })
  }

  var settings = {
    lazyLoad: true,
    dots: props.mobile ? true : false,
    infinite: props.mobile ? true : false,
    slidesToShow: props.mobile ? 1 : props.recomendados.length,
    slidesToScroll: 1,
  }

  return (
    <section className="f-section-recommended-articles">
      <div className="f-title-tab-section-container">
        <TitleTab
          className="f-TitleTab f-TitleTab-pink"
          title={props.mobile ? "Recomendados" : "Recomendados para ti"}
        />
      </div>
      <div className="f-section-recommended-container">
        <Slider {...settings} className="f-recommended-cards-container">
          {props.recomendados.map((recomendado, index) => {
            return (
              <div
                onClick={() => cardRedirect(recomendado)}
                className="f-recommended-card"
                key={index}
              >
                {recomendado.imagenArticuloMiniatura !== null && (
                  <img
                    className="f-recommended-card-img"
                    src={recomendado.imagenArticuloMiniatura.file.url}
                    alt={recomendado.imagenArticuloMiniatura.description}
                  />
                )}
                <div className="f-right-card-section">
                  <label className="f-category-card">
                    {recomendado.categorias[0].titulo}
                  </label>
                  <label className="f-title-card">
                    {recomendado.tituloArticulo}
                  </label>
                </div>
              </div>
            )
          })}
        </Slider>
      </div>
    </section>
  )
}

export default SectionArticleRecommended
